import React, { useState, useEffect, FormEvent } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import SiteWrapper from "../../base/SiteWrapper";

import { useAuth } from '../../hooks/AuthContext';

import {
    Page,
    Button,
    Form,
    Card, Tabs, Tab
} from "tabler-react";

import Params from "../../interfaces/Params";
import Log from "../../interfaces/Log";
import {AuditLogOperationMap} from "../../enum/LogOperationEnum";
import {formatDateToDDMMYYYY} from "../../utils/formatDate";
import api from "../../services/api";

function LogForm() {

    const history = useHistory();
    const { user } = useAuth();

    const { id } = useParams<Params>();
    const apiSender = api()


    const [log, setLog] = useState<Log>();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!user?.master) {
            history.push("/");
            return;
        }
        const fetchLog = async () => {
            if(!!id) {
                const tokenMonitor=  localStorage.getItem('@fidegg:tokenMonitor');
                apiSender.defaults.headers.authorization = `Bearer ${tokenMonitor}`
                const logResponse = await apiSender.get(`log/${id}`);
                if (logResponse.status === 200) {
                    setLog(logResponse.data.data);
                }
                setLoading(false);
                return;
            }
            history.push("/");
            return;
        }

        fetchLog()
    }, [history, id, user]);

    function handleClickCancel(event: FormEvent) {
        event.preventDefault();
        history.goBack();
    }

    const tabGeral = (log: Log) => {
        return (
                    <Form.FieldSet>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <Form.Input
                                    name="table"
                                    type="text"
                                    label="Tabela"
                                    disabled
                                    value={log?.table || ""}
                                />
                            </div>
                            <div className="col-md-3">
                                <Form.Input
                                    name="operation"
                                    type="text"
                                    label="Operação"
                                    disabled
                                    value={AuditLogOperationMap.get(log.operation) || ""}
                                />
                            </div>

                            <div className="col-md-3">
                                <Form.Input
                                    name="date"
                                    type="text"
                                    label="Data"
                                    disabled
                                    value={log?.date ? formatDateToDDMMYYYY(log?.date) : ""}
                                />
                            </div>
                            <div className="col-md-2">
                                <Form.Input
                                    name="method"
                                    type="text"
                                    label="Método"
                                    disabled
                                    value={log?.method || ""}
                                />
                            </div>
                            <div className="col-md-10">
                                <Form.Input
                                    name="route"
                                    type="text"
                                    label="Rota"
                                    disabled
                                    value={log?.route || ""}
                                />
                            </div>

                            <div className="col-md-12">
                                <Form.Input
                                    name="user"
                                    type="text"
                                    label="Usuário"
                                    disabled
                                    value={log?.user || ""}
                                />
                            </div>
                            <div className="col-md-8">
                                <Form.Input
                                    name="session_user_name"
                                    type="text"
                                    label="Usuário do Banco"
                                    disabled
                                    value={log?.session_user_name || ""}
                                />
                            </div>
                            <div className="col-md-4">
                                <Form.Input
                                    name="ip"
                                    type="text"
                                    label="IP"
                                    disabled
                                    value={log?.ip || ""}
                                />
                            </div>
                        </div>
                    </Form.FieldSet>
        )
    }

    const tabDados = (log: Log) => {
        return (
            <Form.FieldSet>
                <Form.Textarea
                    rows={13}
                    name="row_data"
                    disabled
                    value={JSON.stringify(log?.row_data, null, 2) || ""}
                />
            </Form.FieldSet>
        )
    }

    const tabCamposAlterados = (log: Log) => {
        return (
            <Form.FieldSet>
                <Form.Textarea
                    rows={13}
                    name="changed_fields"
                    disabled
                    value={JSON.stringify(log?.changed_fields, null, 2) || ""}
                />
            </Form.FieldSet>
        )
    }

    return (
        <SiteWrapper>
            {loading ? (
                <div>Carregando...</div>
            ) : log ? (
                <Form>
                    <Page.Card
                        title={`Log ${id}`}
                        footer={
                            <Card.Footer>
                                <div className="d-flex">
                                    <Button link onClick={handleClickCancel}>Voltar</Button>
                                </div>
                            </Card.Footer>
                        }
                    >
                    <Card.Body>
                        <Tabs initialTab="Geral">
                            <Tab title="Geral">
                                {tabGeral(log)}
                            </Tab>
                            <Tab title="Dados">
                                {tabDados(log)}
                            </Tab>
                            <Tab title="Campos Alterados">
                                {tabCamposAlterados(log)}
                            </Tab>
                        </Tabs>
                    </Card.Body>
                    </Page.Card>
                </Form>
            ) : (
                <div>Erro ao Carregar Log.</div>
            )}
        </SiteWrapper>
    );

}

export default LogForm;